import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __OPERATION__EVENT__ADMIN__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { PublishedEventCrumbs } from './constants';
import { HttpResponse } from 'shell/models/http-response';
import FormConsumedEvent, {
  ConsumedEventForm,
} from 'system/components/published-events/form-consumed-event';
import { ConsumedEvent } from 'shell/models/consumed-event';
import { transformConsumedEvent } from '../utils/transform-consumed-event';

const ConsumedEventDetailPage = (): React.ReactElement => {
  const params = useParams();

  const navigate = useNavigate();

  const onSubmit = useCallback(() => {
    return;
  }, []);

  const [consumedEvent] = useHttpFetch<HttpResponse<ConsumedEvent>, ConsumedEventForm>(
    `${__OPERATION__EVENT__ADMIN__}/eventoConsumato/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformConsumedEvent,
    }
  );
  return (
    <Fragment>
      <Breadcrumbs
        items={[
          ...PublishedEventCrumbs,
          {
            name: 'Dettaglio Evento Pubblicato',
            path: `/sistema/eventmanager/ricerca-eventi-pubblicati/dettaglio-evento-pubblicato/${params.idPublished}`,
          },
          { name: 'Dettaglio Evento Consumato' },
        ]}
      />
      <FormConsumedEvent
        title="Dettaglio Evento Consumato"
        onOk={onSubmit}
        initialValues={consumedEvent.data as ConsumedEventForm}
        disabled
        onCancel={() => {
          navigate(
            `/sistema/eventmanager/ricerca-eventi-pubblicati/dettaglio-evento-pubblicato/${params.idPublished}`
          );
        }}
      />
    </Fragment>
  );
};

ConsumedEventDetailPage.displayName = 'Consumed Event Page Detail component';

export default ConsumedEventDetailPage;
